<section class="tw-w-full">
  <a [href]="input_src" target="_blank">
    <img
      *ngIf="input_src"
      src="/assets/media/svg/files/pdf.svg"
      alt="Photo"
      class="img-preview"
      [width]="input_imgWidth"
      [height]="input_imgHeight"
      [style]="input_style"
      [style.width]="input_imgWidth"
      [style.height]="input_imgHeight"
    />
  </a>
  <span
    *ngIf="!input_src"
    [style.width]="input_imgWidth"
    [style.height]="input_imgHeight"
    class="tw-flex-center empty"
    [matTooltip]="'messages.imageNotUploaded' | translate"
  >
    <i class="mdi mdi-image mdi-36px"></i>
  </span>
</section>
